const schedule =
  window.setTimeout ||
  window.requestAnimationFrame ||
  window.requestIdleCallback;

export function nextTick(callback: () => void) {
  return new Promise<void>((resolve) => {
    schedule(() => {
      callback();
      resolve();
    });
  });
}

export function nextTickWithResult<TReturn>(callback: () => TReturn) {
  return new Promise<TReturn>((resolve) => {
    schedule(() => resolve(callback()));
  });
}
